import { Dayjs } from "dayjs";
import { Cart, CartProduct, Catalogue, OutletDetails, ProductMap, ProductUI } from "./models";
import { OrderType } from "../../types/types";
import { CreateSecondaryOrderConfig, OneClickOrderConfigType } from "./CreateSecondaryOrder";
import React from "react";
import { ARSQuantities } from "../viewPrimaryOrder/ViewPrimaryOrder";

export enum UOM {
  CASE = "cs",
  PIECE = "pc",
  OTHER = "other",
}

export type RecommendedType = "must-try" | "regular" | "recovery" | undefined;

export interface ProductCard {
  productUI: ProductUI;
  updateQuantityInCart: (
    id: string,
    newQuantity: number,
    type: UOM,
    customerInfo: Record<string, any>,
    allCatalogue: Catalogue[],
    setCart: React.Dispatch<React.SetStateAction<Cart>>
  ) => void;
  orderType?: OrderType;
  handleClickViewSkuDetails?: (product: ProductUI) => void;
  customerInfo: Record<string, any>;
  setCart: React.Dispatch<React.SetStateAction<Cart>>;
  catalogue: Catalogue[],
  addSuggestedQtyState?: number,
  setAddSuggestedQtyState?: (state: number) => void;
  cartProductMap?: ProductMap,
  oneClickOrderConfig?: OneClickOrderConfigType,
  disableStockCheck?: boolean,
  hideStockQtyTile?: boolean,
  enableMOQCheck?: boolean,
  showListView?: boolean,
  ARSQuantities?: ARSQuantities,
  isRestockItem?: boolean
}

export interface CartProductCardProps {
  product: CartProduct;
  updateQuantityInCart: (
    id: string,
    newQuantity: number,
    type: UOM,
    customerInfo: Record<string, any>,
    allCatalogue: Catalogue[],
    setCart: React.Dispatch<React.SetStateAction<Cart>>
  ) => void;
  orderType?: OrderType;
  handleClickViewDetails?: (product: CartProduct) => void;
  resetCart?: () => void;
  totalProducts?: number;
  customerInfo: Record<string, any>;
  setCart: React.Dispatch<React.SetStateAction<Cart>>;
  catalogue: Catalogue[],
  disableStockCheck?: boolean,
  enableMOQCheck?: boolean,
}

export interface SelectedCustomer {
  outletCode: number;
  customerName: string;
  salesRep: string;
  shippingAddress: string;
  orderType: string;
  customerChannel: string;
  paymentMethod: string;
  billDate: Dayjs;
  deliveryDate: Dayjs;
  deliveryMode: string;
}

export interface CustomerInfo {
  beatNameToIdMap: Record<string, string>,
  orderType: string[],
  selectedCustomerInfo: Record<string, any>,
  setSelectedCustomerInfo: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  outletsList: OutletDetails[];
  allOutletsList: OutletDetails[];
  beatList: string[];
  beatRecord: Record<string, Set<string>>;
  routeIdNameMap: any;
  expandForm: boolean;
  salesReps?: string[];
  salesRepDisplayNameToLoginIdMapping?: Record<string, string>;
  setExpandForm: React.Dispatch<React.SetStateAction<boolean>>;
  setDifferentShippingAddress?: React.Dispatch<React.SetStateAction<boolean>>;
  selectedBeat: string;
  setSelectedBeat: React.Dispatch<React.SetStateAction<string>>;
  setFilteredBeats: React.Dispatch<React.SetStateAction<string[]>>;
  selectedSalesRep?: string;
  setSelectedSalesRep?: React.Dispatch<React.SetStateAction<string>>;
  setOutletDetails?: React.Dispatch<React.SetStateAction<OutletDetails[]>>;
  setIsCounterSaleOrder?: React.Dispatch<React.SetStateAction<boolean>>;
  isCounterSaleOrder?: boolean;
  setOutletApprovalSent?:React.Dispatch<React.SetStateAction<boolean>>;
  orderFullfillmentTime?: number;
  setOutletReferenceId?: React.Dispatch<React.SetStateAction<string>>;
  createSecondaryOrderConfig: CreateSecondaryOrderConfig;
  setSelectedOutletCode?: React.Dispatch<React.SetStateAction<string>>;
  selectedOutletCode?: string;
  routeIdDetails?: any;
}

export interface FilterOption {
  name: string;
  checked: boolean;
}

export interface FilterOptions {
  [key: string]: FilterOption[];
}

export interface FilterSectionProps {
  title: string;
  options: FilterOption[];
  handleChange: (index: number) => void;
  toggleShowAll: () => void;
  showAll: boolean;
}

export interface FilterProductType {
  filterOption: Record<string, any>;
  selectedOptions: Record<string, FilterOption[]>;
  updateFilterSelection: (filterType: string, options: FilterOption[]) => void;
  customHeight?: string;
}

export interface ExtendedAttributes {
  se_id: string;
  sm_id: string;
  asm_id: string;
  se_name: string;
  sm_name: string;
  asm_name: string;
  supplier: string[];
  channel_id: string;
  oldMobileNo: string;
  vpo_class_id: string;
  pricelist_code: string;
  admin_entity_id: string;
  admin_entity_desc: string;
  marketarea_territory: string;
  marketarea_operational_id: string;
  "parent-0-0-id": string;
  shipTo: Record<any, any>;
  preferredPaymentMode: string;
  salesrep?: string;
  counterSalesOutletDMS?: boolean;
  OutletPaymentmode?: string;
}

export interface OutletDetailsType {
  id: string;
  activeStatus: string;
  activeStatusReason: string;
  changes: any[];
  changed: boolean;
  extendedAttributes: ExtendedAttributes;
  outletCode: string;
  userName: string;
  outletName: string;
  outletType: string;
  address: string;
  contactno: string;
  mapped: boolean;
  location: Record<string, any>;
  channel: string;
  immediateParent: string;
  latitude: number;
  longitude: number;
  outletClass: string;
  distributionChannel: string;
  create: boolean;
}
